const resources = {
    free: 'FREE',
    biFreeShip: 'Beauty Insiders enjoy *FREE standard shipping* on all orders.',
    biFreeShipTest: 'Your Order qualifies for *{color:red}FREE standard shipping.{color}*'
};

module.exports = function getResource(label) {
    return resources[label];
};
